import React from "react";
import { inject, observer } from "mobx-react";
import Master from "@templates/master";
import CategoryGrid from "@components/Grid/CategoryGrid";


@inject("store")
@observer
export default class BerikssonCategory extends React.Component {
    constructor(props) {
        super(props);
        this.pickProduct = this.pickProduct.bind(this);
        this.resetProductIterator = this.resetProductIterator.bind(this);
        this.productsCount = this.productsCount.bind(this);

        //this.RenderProducts = [];
    }


    pickProduct() {
        if (this.ProductIterator.length === 0) {
            return null;
        }
        const item = this.props.store.navigation.ProductsView[this.ProductIterator[0]];

        this.ProductIterator = this.ProductIterator.slice(1);

        return item;
    }

    resetProductIterator() {

        //this.ProductIterator = Object.keys(this.RenderProducts);
        this.ProductIterator = Object.keys(this.props.store.navigation.ProductsView);

    }

    productsCount() {

        return this.ProductIterator.length;
    }



    render() {

        //this.RenderProducts = this.props.store.navigation.ProductsView;
        //this.resetProductIterator();

        //const searchQuery = this.props.store.navigation.getFreetextFromLocation();

        const model = this.props.navigation.pageContent;//model;
        const repeater = model.Repeater ? model.Repeater.grid : null;

        const serverRender = typeof window === 'undefined';

        const headerName = model.Name;///!(model.Properties.heroGrid.sections && model.Properties.heroGrid.sections[0].rows.length) ? model.Name : null;

        return (
            
            <Master {...this.props}>
                
                 <div className="container-fluid">
                     <CategoryGrid
                         headerName={headerName}
                         {...this.props}
                          model={model.Properties.grid}
                          repeater={repeater}
                         // resetProductIterator={this.resetProductIterator}
                         // pickProduct={this.pickProduct}
                         // productsCount={this.productsCount}
                     />
                 </div>
            </Master>
        );
    }
}


